import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col
} from "reactstrap";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getOnboardingData } from "../../redux/loginSlice";
import { fundedInvoicesData } from "../../locales/en";
import FundManualTable from "../table/all-tables/fundtable/FundManualTable";
import "./fund.scss";
import ErrorBoundary from "../error-boundary";
import ListViewFallback from "../error-boundary/fallback/ListViewFallback";
import {
  ACTIVE,
  COMPLETED,
  STATUS_1,
  STATUS_2
} from "../../utils/constants/appConstants";
import FundedTab from "./fundedtab/FundedTab";
function Fund({ profileUserData }) {
  const [activeTab, setActiveTab] = useState(STATUS_1);
  const location = useLocation();
  const hash = location.hash;
  const [onboardingStatus, setOnboardingStatus] = useState("");
  const onboardingData = useSelector((state) => state.login.onboardingData);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleGetOnboardingData = async () => {
      if (onboardingData && onboardingData?.onboardingStatus !== COMPLETED) {
        const response = await dispatch(getOnboardingData()).unwrap();
        setOnboardingStatus(response?.data?.data?.onboardingStatus);
      } else {
        setOnboardingStatus(onboardingData?.onboardingStatus);
      }
    };
    handleGetOnboardingData();
  }, []);

  useEffect(() => {
    if (hash === "#funded") {
      setActiveTab(STATUS_2);
    }
  }, [hash]);

  return (
    <div className="invoice-tab-wrap">
      <div className="container">
        <Nav tabs className="invoice-nav custom-nav-uidesign">
          <NavItem>
            <NavLink
              className={activeTab === STATUS_1 ? ACTIVE : ""}
              onClick={() => setActiveTab(STATUS_1)}
            >
              {fundedInvoicesData?.toFund?.toFundNav}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === STATUS_2 ? ACTIVE : ""}
              onClick={() => setActiveTab(STATUS_2)}
            >
              {fundedInvoicesData?.funded?.fundedNav}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab} id="invoice-tabcontent">
          <TabPane tabId={STATUS_1}>
            <Row>
              <Col sm="12">
                <div className="fundtable-wrap">
                  <ErrorBoundary fallback={<ListViewFallback />}>
                    <FundManualTable
                      profileUserData={profileUserData}
                      setActiveTab={setActiveTab}
                      onboardingStatus={onboardingStatus}
                    />
                  </ErrorBoundary>
                </div>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={STATUS_2}>
            <Row>
              <Col sm="12">{activeTab === STATUS_2 && <FundedTab />}</Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
}

Fund.propTypes = {
  profileUserData: PropTypes.object.isRequired
};

export default Fund;
